import { jsxs as S, Fragment as F, jsx as a } from "react/jsx-runtime";
import { useRef as L, useContext as y, useState as C, useEffect as N } from "react";
import { useTranslation as V } from "react-i18next";
import { NumericFormat as k } from "react-number-format";
import "../../../../fields/FieldContainer/index.js";
import "../../../../fields/Checkbox/index.js";
import "../../../../fields/ContentEditable/index.js";
import "../../../../fields/DateInput/index.js";
import "date-fns";
import "classnames";
import "../../../../index-YV3Z4nmr.js";
import "reactjs-popup";
import { ThemeContext as W } from "../../../../components/ThemeContext/index.js";
import "../../../../components/Button/index.js";
import "../../../../components/Modal/index.js";
import "react-dropzone";
import "../../../../components/Breadcrumbs/index.js";
import "react-hook-form";
import "sanitize-html";
import "i18next";
import "@dnd-kit/core";
import "@dnd-kit/sortable";
import "immutability-helper";
import { PRODUCT_VAT_IDS as v } from "../../../../helpers/productsCalcFunctions.js";
import D from "../../../../fields/Input/index.js";
import "../../../../components/Tooltip/index.js";
import "react-dom";
import "../../../../fields/InputTooltip/index.js";
import "../../../../fields/PhoneInput/index.js";
import "../../../../fields/SocialSelect/index.js";
import R from "../../../../fields/Switcher/index.js";
import "../../../../fields/Textarea/index.js";
const j = "forma-ui__fill-products-table-input__input", B = "forma-ui__fill-products-table-input__tooltip", P = "forma-ui__fill-products-table-input__switcher", z = "forma-ui__fill-products-table-input__switcherLabel", A = "forma-ui__fill-products-table-input__textValue", r = {
  input: j,
  tooltip: B,
  switcher: P,
  switcherLabel: z,
  textValue: A
}, bt = ({
  id: o,
  productId: s,
  type: l,
  value: i = "",
  isSimilar: f,
  canApplyToAll: w,
  onChangeItem: _,
  onChangeAll: h,
  readOnly: d
}) => {
  const e = L(null), { t: x } = V(), { lang: b } = y(W), [p, c] = C(!1), $ = p && !!i && !f && w && !!h, g = v.includes(o) && i === x("uikit:without_vat") && !p, T = l && ["percentage", "money", "decimal"].includes(l);
  return N(() => {
    if (!e.current)
      return;
    const t = e.current.closest("td"), n = t.closest("table");
    let u = "auto", m = `${t.offsetWidth / 2 - e.current.offsetWidth / 2}px`;
    t.offsetLeft || (m = "0px"), t.offsetLeft + t.offsetWidth === n.offsetWidth && (m = "auto", u = "0px"), e.current.style.opacity = "1", e.current.style.top = `${-e.current.offsetHeight - 6}px`, e.current.style.left = m, e.current.style.right = u;
  }, [e.current, p]), /* @__PURE__ */ S(F, { children: [
    $ && /* @__PURE__ */ a("div", { className: r.tooltip, onClick: () => h(i), ref: e, children: /* @__PURE__ */ a(
      R,
      {
        id: `apply_to_all${s}_${o}`,
        name: "apply_to_all",
        size: "small",
        checked: f,
        label: x("uikit:apply_to_all"),
        containerClass: r.switcher,
        labelClass: r.switcherLabel
      }
    ) }),
    g && /* @__PURE__ */ a("span", { className: r.textValue, children: i }),
    T ? /* @__PURE__ */ a(
      k,
      {
        id: `product_input_${s}_${o}`,
        name: `product_value_${s}_${o}`,
        className: r.input,
        onChange: (t) => _(t.target.value),
        onFocus: () => c(!0),
        onBlur: () => setTimeout(() => c(!1), 250),
        value: i,
        thousandSeparator: b === "ru" ? " " : ",",
        decimalSeparator: b === "ru" ? "," : ".",
        decimalScale: 2,
        fixedDecimalScale: l === "money",
        suffix: l === "percentage" ? "%" : void 0,
        inputMode: "decimal",
        isAllowed: (t) => {
          const { floatValue: n } = t;
          return n === void 0 || n < (l === "percentage" ? 100 : 1e9);
        },
        readOnly: d
      }
    ) : /* @__PURE__ */ a(
      D,
      {
        id: `product_input_${s}_${o}`,
        name: `product_value_${s}_${o}`,
        className: r.input,
        onChange: (t) => _(t.target.value),
        onFocus: () => c(!0),
        onBlur: () => setTimeout(() => c(!1), 250),
        maxLength: 250,
        value: i,
        readOnly: d
      }
    )
  ] });
};
export {
  bt as default
};
